import s from "../RollingSubmissionDetail.module.css";
import { STATUS_BADGE_CLASS, STATUS_BADGE_LABELS } from "../constants";

export function StatusBadge({ status }: { status: string }) {
  return (
    <span className={`${s.statusBadge} ${STATUS_BADGE_CLASS[status] ?? ""}`}>
      <span className={s.statusBadgeDot} />
      {STATUS_BADGE_LABELS[status] ?? status}
    </span>
  );
}
